/* eslint-disable */
import * as React from 'react';

import AppPage from '@/ui/AppPage/AppPage';
import Box from '@mui/material/Box';
import Permissions from '@/lib/permissions';
import UsersTable from './UsersTable';

function UsersPage() {
  return (
    <AppPage titlett="admin:page.users" needPermission={[Permissions.Administration]}>
      <Box m={0} style={{ height: '100%' }}>
        <UsersTable />
      </Box>
    </AppPage>
  );
}

export default UsersPage;
